import http from '@/utils/http';

export default {
  async getById(id) {
    return await http.get(`/api/comissao/get/${id}`);
  },
  async getRelatorioById(id) {
    return await http.get(`/api/comissao/relatorio/${id}`);
  },  
  async insert(data) {
    return await http.post('/api/comissao/insert', data);
  },
  async update(data) {
    return await http.post('/api/comissao/update', data);
  },
  async delete(data) {
    return await http.post('/api/comissao/delete', data);
  },
  async upload(data) {
    return await http.post('/api/comissao/upload', data);
  }
};